export default {
    props: { page: String, required: true },
    methods: {
        updateBrowserTitle() {
            document.title = this.browserTitle ? (this.browserTitle + " | Ameriflex") : "Ameriflex";
        }
    },
    watch: {
        browserTitle: {
            immediate: true,
            handler: "updateBrowserTitle"
        }
    }
}



// WEBPACK FOOTER //
// ./src/framework/utils/parent-view-mixin.js